import { DialogContentText } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import React, { useEffect, useRef, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useMessageBox } from '../../context/MessageBox';
import { logout } from '../../services/auth';
import colors from '../../styles/settings/colors';
import * as S from './styles';

export function MessageBox() {
  const searchInput = useRef(null);
  const history = useHistory();
  const { messageData, messageType, setMessageData } = useMessageBox();
  const [open, setOpen] = useState(false);
  const [messages, setMessages] = useState([]);
  const [currentlyMessage, setCurrentlyMessage] = useState({});
  const [indexMessage, setIndexMessage] = useState(0);

  const checkNextMessage = () => {
    if (messages?.length > indexMessage + 1) {
      setOpen(false);
      setTimeout(() => {
        setIndexMessage((prevIndex) => prevIndex + 1);
        setCurrentlyMessage(messages[indexMessage + 1]);
        setOpen(true);
      }, 500);
      return;
    }
    setOpen(false);
  };

  const handleCustomAction = () => {
    switch (messageType) {
      case 'CHANGE_PASSWORD':
        logout();
        // history.push('/app/login');
        setMessageData('');
        break;

      default:
        break;
    }
  };

  const handleClose = (event, reason) => {
    if (reason === 'backdropClick') {
      return;
    }

    if (messageType) {
      handleCustomAction();
    }

    checkNextMessage();
  };

  const checkAutoClose = () => {
    if (currentlyMessage.fecharAutomaticamente > 0) {
      setTimeout(() => {
        handleClose();
      }, currentlyMessage.fecharAutomaticamente * 1000);
    }
  };

  useEffect(() => {
    setTimeout(() => {
      searchInput?.current?.focus?.();
    }, 200);
    if (messageData?.length > 0) {
      checkAutoClose();
      setMessages(messageData);
      setCurrentlyMessage(messageData?.[0]);
      setIndexMessage(0);
      setOpen(true);
    }
  }, [messageData]);

  return (
    <S.DialogModal
      open={open}
      onClose={handleClose}
      disableEscapeKeyDown
      className="dialog-parent"
      widthContainer={currentlyMessage?.mensagemBoxLargura}
    >
      <S.DialogContainer borderColor={currentlyMessage?.tituloCorDeFundo}>
        <div className="margin-container">
          <S.Title
            bgColor={currentlyMessage?.tituloCorDeFundo}
            color={currentlyMessage?.tituloCorDaFonte}
            heightTitle={currentlyMessage?.TituloBoxAltura}
            style={{
              height: `${
                currentlyMessage?.tituloBoxAltura > 0
                  ? `${currentlyMessage?.tituloBoxAltura}${currentlyMessage?.mensagemBoxUnidade}`
                  : 'auto'
              }`,
            }}
            fontTitle={currentlyMessage?.tituloTamanhoDaFonte}
          >
            <span dangerouslySetInnerHTML={{ __html: currentlyMessage?.tituloTexto }}></span>
          </S.Title>

          <S.BodyText
            bgColor={currentlyMessage?.mensagemCorDeFundo}
            color={currentlyMessage?.mensagemCorDaFonte}
            messageFontSize={currentlyMessage?.mensagemTamanhoDaFonte}
            style={{
              height: `${
                currentlyMessage?.mensagemBoxAltura > 0
                  ? `${currentlyMessage?.mensagemBoxAltura}${currentlyMessage?.mensagemBoxUnidade}`
                  : 'auto'
              }`,
            }}
          >
            <DialogContentText>
              <div
                className="message-html"
                dangerouslySetInnerHTML={{ __html: currentlyMessage?.mensagemTexto }}
                style={{
                  textAlign: currentlyMessage?.mensagemTextoAlinhamento?.toLowerCase(),
                }}
              ></div>
            </DialogContentText>
          </S.BodyText>

          <S.DialogActionsMessage backgroundColor={currentlyMessage.barraBotoesCorDeFundo}>
            {currentlyMessage?.botao3Ativo && (
              <Button
                onClick={handleClose}
                style={{
                  color: currentlyMessage.botao3CorDaFonte,
                  backgroundColor: currentlyMessage.botao3CorDeFundo,
                  textTransform: 'initial',
                  fontWeight: '400',
                }}
              >
                {currentlyMessage?.botao3Texto}
              </Button>
            )}
            {currentlyMessage?.botao2Ativo && (
              <Button
                onClick={handleClose}
                style={{
                  color: currentlyMessage.botao2CorDaFonte,
                  backgroundColor: currentlyMessage.botao2CorDeFundo,
                  textTransform: 'initial',
                  fontWeight: '400',
                }}
              >
                {currentlyMessage?.botao2Texto}
              </Button>
            )}
            {currentlyMessage?.botao1Ativo && (
              <Button
                onClick={handleClose}
                autoFocus
                focusVisible
                ref={searchInput}
                style={{
                  color: currentlyMessage?.botao1CorDaFonte || '#fff',
                  backgroundColor: currentlyMessage?.botao1CorDeFundo || colors.sanMarino,
                  textTransform: 'initial',
                  fontWeight: '400',
                }}
              >
                {currentlyMessage?.botao1Texto || 'Fechar'}
              </Button>
            )}
          </S.DialogActionsMessage>
        </div>
      </S.DialogContainer>
    </S.DialogModal>
  );
}
